import {Controller} from "stimulus"

// Helper: parse date from input value trying common formats
function parseDateFromInputValue(val) {
    // Try Date constructor first
    let d = new Date(val);
    if (!isNaN(d.getTime())) return d;
    // Try replacing space with 'T' for ISO-like
    d = new Date(val.replace(' ', 'T'));
    if (!isNaN(d.getTime())) return d;
    // Try YYYY-MM-DD only (no time) -> treated as local midnight
    const m = val.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
        const y = parseInt(m[1], 10), mo = parseInt(m[2], 10) - 1, da = parseInt(m[3], 10);
        return new Date(y, mo, da, 0, 0, 0, 0);
    }
    return null;
}

// Helper: format end date to resemble the start value's format
function formatDateLike(startVal, dateObj) {
    // Detect if time is present in start value (colon or 'T')
    const hasTime = /\d:\d/.test(startVal) || /T\d{2}:\d{2}/.test(startVal);
    const pad = (n) => String(n).padStart(2, '0');
    const y = dateObj.getFullYear();
    const m = pad(dateObj.getMonth() + 1);
    const d = pad(dateObj.getDate());
    if (!hasTime) {
        return `${y}-${m}-${d}`;
    }
    const hh = pad(dateObj.getHours());
    const mm = pad(dateObj.getMinutes());
    // Mirror space vs 'T' choice based on startVal
    const joiner = startVal.includes('T') ? 'T' : ' ';
    return `${y}-${m}-${d}${joiner}${hh}:${mm}`;
}

export default class extends Controller {

    connect() {
        console.log("connect from fieldBehaviorController");
        const inputs = this.element.querySelectorAll('input, select, checkbox');
        Array.from(inputs).map(function (inputElement) {
            if (!!inputElement) {
                if (!!inputElement.labels && inputElement.labels.length > 0) {
                    labelDisplayer(inputElement)

                }
            }
        })

    }

    manageLabel(event) {
        labelDisplayer(event.target);
    }

    preventEnter(e) {
        const code = e.keyCode || e.which;
        if (code == 13) {
            e.preventDefault();
            return false;
        }
    }

    setEndByStart(event) {
        const startInput = event.target;
        const minutesStr = startInput.dataset.autoSetEndByMinutes;
        if (!minutesStr) { return; }
        const minutes = parseInt(minutesStr, 10);
        if (isNaN(minutes)) { return; }

        const startVal = startInput.value;
        if (!startVal) { return; }

        // Try to parse the date/time from the start input value
        let startDate = parseDateFromInputValue(startVal);
        if (!startDate) { return; }

        // Add minutes
        const endDate = new Date(startDate.getTime() + minutes * 60000);

        // Find corresponding frame_end input by matching name
        const formEl = startInput.closest('form') || document;
        const startName = startInput.getAttribute('name');
        if (!startName) { return; }
        const endName = startName.replace(/\[frame_start\]$/, '[frame_end]');
        let endInput = null;
        if (endName !== startName) {
            endInput = formEl.querySelector(`input[name="${CSS.escape(endName)}"]`);
        }
        // Fallback: look for an input whose name contains the same prefix and ends with [frame_end]
        if (!endInput) {
            const prefix = startName.replace(/\[frame_start\].*$/, '');
            endInput = Array.from(formEl.querySelectorAll('input'))
                .find(i => i.name && i.name.startsWith(prefix) && /\[frame_end\]$/.test(i.name));
        }
        if (!endInput) { return; }

        // Format end date similar to start value (preserve presence of time)
        const formatted = formatDateLike(startVal, endDate);
        if (!formatted) { return; }
        endInput.value = formatted;
        // Trigger input/change events so any listeners update UI/labels
        endInput.dispatchEvent(new Event('input', { bubbles: true }));
        endInput.dispatchEvent(new Event('change', { bubbles: true }));
        // Update floating labels if present
        labelDisplayer(endInput);
    }

}

function labelDisplayer(inputElement) {
    if (document.body.contains(inputElement)) {
        if (inputElement.value != "" || inputElement.classList.contains('input')) {
            inputElement.classList.add('label-showing');
            if (inputElement.labels && inputElement.labels[0]) {
                inputElement.labels[0].classList.add('label-showing');
            }
            inputElement.classList.remove('label-hidden');
            if (inputElement.labels && inputElement.labels[0]) {
                inputElement.labels[0].classList.remove('label-hidden');
            }
        } else {
            inputElement.classList.remove('label-showing');
            if (inputElement.labels && inputElement.labels[0]) {
                inputElement.labels[0].classList.remove('label-showing');
            }
            inputElement.classList.add('label-hidden');
            if (inputElement.labels && inputElement.labels[0]) {
                inputElement.labels[0].classList.add('label-hidden');
            }

        }
    }
}